import React from 'react';
import { useTranslation } from 'react-i18next';
import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const ContactSummary = (props) => {
  const { t } = useTranslation();
  const { contact } = props;

  return (
    <>
      <h3>{t('checkout.summary.contact.title')}</h3>
      <p data-dd-privacy={DATADOG_PRIVACY_LEVELS.MASK}>{contact.email}</p>
      <p data-dd-privacy={DATADOG_PRIVACY_LEVELS.MASK}>{contact.phone}</p>
    </>
  );
};

export default ContactSummary;
